import { useMemo } from 'react';
import { useApi } from './api';

export const useSeasons = (order) => {
  const [data, loading, error] = useApi('seasons');

  const seasons = useMemo(
    () => (order === 'desc' ? data?.reverse() : data),
    [data, order]
  );

  return [seasons, loading, error];
};
